import { render } from "./TeacherList.vue?vue&type=template&id=690e01ca&scoped=true&ts=true"
import script from "./TeacherList.vue?vue&type=script&lang=ts"
export * from "./TeacherList.vue?vue&type=script&lang=ts"

import "./TeacherList.vue?vue&type=style&index=0&id=690e01ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690e01ca"]])

export default __exports__